module.exports = __webpack_public_path__ + "static/media/icon_store.143eb46a.svg";